import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useProvince = (id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useProvincecontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useProvince-${id}`);
  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useProvince-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useProvince-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const getProvince = async (customQuery) => {
    try {
      loading.value = true;
      result.value = null;
      const res = await context.$xbuy.api.getProvince(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    getProvince: getProvince,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
